export default __webpack_public_path__ + "static/macbook1-15a6138c41666b81a5e2fb9616a27488.png";